import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Gradients } from '@picsart/design-system/foundation/colors';

export default createUseStyles(
  {
    horizontalContainer: {
      '@media screen and (max-width: 480px)': {
        margin: [40, 0],
      },
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    },
    titleWrapper: {
      marginBottom: Spacings.s12,
    },
    title: {
      '@media screen and (max-width: 768px)': {
        fontSize: FontSizes.s30,
        lineHeight: LineHeights.l48,
      },
      '& > span > p > i': {
        fontStyle: 'normal',
        WebkitTextFillColor: 'transparent',
        WebkitBackgroundClip: 'text',
        background: Gradients.pro,
      },
    },
    descriptionWrapper: {
      marginBottom: Spacings.s24,
    },
    description: {
      fontWeight: FontWeights.medium,
    },
    carouselWrapper: {
      maxWidth: '90%',
      marginBottom: Spacings.s24,
      '@media screen and (max-width: 480px)': {
        maxWidth: '100%',
        padding: [Spacings.s0, Spacings.s12],
      },
    },
    carousel: {
      '& > div > div': {
        padding: Spacings.s24,
      },
    },
    button: {
      '@media screen and (max-width: 480px)': {
        width: 352,
      },
    },

    // Skeleton styles
    skeletonTitle: {
      width: 800,
      height: 75,
      '@media screen and (max-width: 480px)': {
        width: 336,
        height: 100,
      },
    },
    skeletonDescription: {
      width: 1000,
      height: 40,
      '@media screen and (max-width: 480px)': {
        width: 336,
        height: 90,
      },
    },
    skeletonCarouselWrapper: {
      padding: Spacings.s24,
      display: 'flex',
      gap: Spacings.s16,
      '@media screen and (max-width: 480px)': {
        width: 380,
      },
    },
    skeletonCarousel: {
      width: 160,
      height: 200,
      borderRadius: Spacings.s16,
    },
    skeletonButton: {
      width: 125,
      height: 50,
      borderRadius: Spacings.s56,
      '@media screen and (max-width: 480px)': {
        width: 352,
      },
    },
  },
  { name: 'TemplatesCategoryCarousel' },
);
